import Style from "./style"

import { useSearchParams } from "react-router-dom"
import sortIcon from "shared/assets/ic_sort.svg"

const SortableHeader = ({ 
    children, 
    sortKey, 
    size, 
    prefix = "", 
    ...props 
}) => {
    const [searchParams, setSearchParams] = useSearchParams()

    const getParamName = (paramName) => prefix ? `${prefix}_${paramName}` : paramName

    const currentSortBy = searchParams.get(getParamName("sortBy"))
    const currentSortDirection = searchParams.get(getParamName("sortDirection"))

    const handleSort = (e) => {
        e.stopPropagation()

        const newParams = {}
        
        searchParams.forEach((value, key) => {
            newParams[key] = value
        })

        if (currentSortBy !== sortKey) {
            newParams[getParamName("sortBy")] = sortKey
            newParams[getParamName("sortDirection")] = "ASC"
        } else if (currentSortDirection === "ASC") {
            newParams[getParamName("sortBy")] = sortKey
            newParams[getParamName("sortDirection")] = "DESC"
        } else if (currentSortDirection === "DESC") {
            delete newParams[getParamName("sortBy")]
            delete newParams[getParamName("sortDirection")]
        } else {
            newParams[getParamName("sortBy")] = sortKey
            newParams[getParamName("sortDirection")] = "ASC"
        }

        // Reset to first page when sorting
        // newParams.page = 1
        
        setSearchParams(newParams)
    }

    const isActive = currentSortBy === sortKey
    const direction = isActive ? currentSortDirection : null

    return (
        <Style.Container {...props}>
            {children}
            {sortKey && (
                <Style.SortIcon 
                    src={sortIcon} 
                    alt="sort" 
                    onClick={handleSort}
                    $isActive={isActive}
                    $direction={direction}
                />
            )}
        </Style.Container>
    )
}

export default SortableHeader